import { ANALYTICS_EVENTS } from '@/constants/analytics';
import { paths } from '@primum/api-types';
import { segmentClient } from '@/util/analytics';
import { fetchClient } from '@/util/fetchClient';

export type NotificationPreferenceBodyV2 =
  paths['/v2/users/me/notification-preferences']['patch']['requestBody']['content']['application/json'];

export async function setNotificationPreferenceV2({
  channel,
  event,
  enabled,
  username,
}: NotificationPreferenceBodyV2 & { username?: string }) {
  try {
    const { data } = await fetchClient.PATCH('/v2/users/me/notification-preferences', {
      body: {
        channel,
        event,
        enabled,
      },
    });

    segmentClient.track(ANALYTICS_EVENTS.NOTIFICATIONS_PREFERENCES_UPDATED, {
      username,
      preference: event,
      preferenceType: channel,
      value: enabled,
    });

    return data;
  } catch (error) {
    segmentClient.track(ANALYTICS_EVENTS.NOTIFICATIONS_PREFERENCES_UPDATE_FAILED, {
      notification_preference: error ? JSON.stringify(error) : 'Unknown error',
    });

    throw error;
  }
}
